import { User } from "@radarly/models/user";

export interface MemberRepo {
  getMember(user: User["id"]): Promise<User>;
}

export const MemberRepoUID = Symbol("Radarly/MemberRepo");
